import { FETCH_BATTERY, LATEST_DATA } from "../../actions/types";

const INITIAL_STATE = {
  results: [
    {
      value: null
    }
  ]
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LATEST_DATA:
      return payload.battery;
    case FETCH_BATTERY:
      return payload.data;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/helpers/battery_reducer.js